import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import apiService from '../services/api'

const AuthLogin = () => {
  const [identifier, setIdentifier] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const [params] = useSearchParams()

  // Empêcher le scroll sur mobile
  useEffect(() => {
    const isMobile = window.innerWidth < 768
    if (isMobile) {
      document.body.style.overflow = 'hidden'
      document.body.style.height = '100vh'
    }
    
    return () => {
      document.body.style.overflow = ''
      document.body.style.height = ''
    }
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const res = await apiService.post('/auth/login', { identifier, password })
      localStorage.setItem('user_token', res.data.token)
      try { localStorage.setItem('user_role', res.data?.user?.role || '') } catch {}
      const redirect = params.get('redirect')
      if (redirect) {
        navigate(redirect)
        return
      }
      const role = res.data?.user?.role
      if (role === 'admin') {
        navigate('/admin')
      } else {
        navigate('/catalogue-materiels')
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de connexion')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="h-screen bg-white md:bg-gray-100 flex flex-col md:items-center md:justify-center px-4 pt-20 pb-4 md:p-6 overflow-hidden md:min-h-screen">
      <div className="bg-white border-0 md:border border-gray-200 rounded-xl p-6 shadow-none md:shadow-lg w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">Se connecter</h1>
        {error && <p className="text-red-600 text-sm mb-3">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email ou pseudo</label>
            <input className="input-field" value={identifier} onChange={e => setIdentifier(e.target.value)} placeholder="email ou pseudo" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Mot de passe</label>
            <input type="password" className="input-field" value={password} onChange={e => setPassword(e.target.value)} placeholder="********" />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={loading}>{loading ? 'Connexion...' : 'Se connecter'}</button>
        </form>
        <div className="mt-4 text-center text-sm text-gray-600 space-y-2">
          <p>
            Pas de compte ? <Link to="/register" className="text-orange-600 hover:underline">Créer un compte</Link>
          </p>
          <p>
            <Link to="/forgot-password" className="text-orange-600 hover:underline">Mot de passe oublié</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default AuthLogin


